import React, { useEffect, useRef, useState } from 'react';
import { useHistory, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";

import * as R from "ramda";
import * as Loadings from '../../../constants/loadings/funecap/selfcare';
import { LoadingState } from '../../../_common/loadingState';

import { SelfcareFilter } from './filter';
import { SelfcarePagination } from './pagination';
import { ChangeOperator } from "./../changeOperator";

import { UpdateOperator } from "../../../actions/funecap/selfcare";

export const SelfcareMain = ({ selfcareState, partners, pageSearch, setPageSearch, routerQuery, operatorId, pageQuery, teleconseillers, isPartner, userId }) => {
	const history = useHistory();
	const dispatch = useDispatch();

	const [usersToDisplay, setUsersToDisplay] = useState(selfcareState.items);
	const [partnersToDisplay, setPartnersToDisplay] = useState(partners);
	const operatorIdOptions = { myUsers: "Mes RDV", allUsers: "Tous les RDV" };

	
	const searchRef = useRef();
	let timer = null;

	const [selectedUser, setSelectedUser] = useState(undefined);

	useEffect(() => {
		if (!R.isNil(searchRef.current) && pageSearch !== "") {
			searchRef.current.focus();
		}

		const pageQuery = new URLSearchParams(window.location.search);
		if (pageSearch == "") {
			pageQuery.delete("search");
			history.push(`/funecap/selfcare?${pageQuery.toString()}`);
			return;
		}
		pageQuery.set("search", pageSearch);

		clearTimeout(timer);
		timer = setTimeout(() => {
			history.push(`/funecap/selfcare?${pageQuery.toString()}`);
		}, 1000);

		return () => clearTimeout(timer);
	}, [pageSearch]);

	useEffect(() => {
		setPartnersToDisplay(partners);
	}, [partners]);

	useEffect(() => {
		setUsersToDisplay(selfcareState.items);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selfcareState]);

	if (window.location.search === "") {
		return (
			<Redirect
				to={`/funecap/selfcare?page=${1}&operatorId=${operatorId}${pageSearch !== "" ? "&search=" + pageSearch : ""}${routerQuery.sortBy !== "" ? "&sortBy=" + routerQuery.sortBy : ""}${routerQuery.sortDesc === "" ? "" : routerQuery.sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}${
					!R.isNil(routerQuery.fromMeetingDate) ? "&fromMeetingDate=" + routerQuery.fromMeetingDate : ""
				}${!R.isNil(routerQuery.toMeetingDate) ? "&toMeetingDate=" + routerQuery.toMeetingDate : ""}`}
			/>
		);
	}

	return (
		<article className="view-calc pt-3 mb-auto pb-sm pt-gd-3 pt-lg-4">
			<div className="container-fluid">
				<SelfcareFilter
					selfcareState={selfcareState}
					operatorIdOptions={operatorIdOptions}
					searchRef={searchRef}
					pageSearch={pageSearch}
					setPageSearch={setPageSearch}
					partnersToDisplay={partnersToDisplay}
					routerQuery={routerQuery}
					operatorId={operatorId}
					pageQuery={pageQuery}
					teleconseillers={teleconseillers}
					userId={userId}
				/>
			</div>
			<div className="auto-view h-100 mb-auto">
				{selfcareState.isLoading.includes(Loadings.FETCHING_SELFCARE_FILES) ? (
					<LoadingState />
				) : (
					<div className="container-fluid">
						{!R.isEmpty(usersToDisplay) ? (
							<section className="block grid-sm grid-sm-min grid-lg-narrow grid-hd-auto">
								{usersToDisplay.map((user) => {
									return (
										<div className="card text-center h-100 rounded shadow--hover" key={user.id}>
											<div className="card-body my-auto px-3 flex-column">
												{/* <div className="card-body pt-3 pb-2 shadow h-100 rounded mb-2 text-center"> */}
												<Link
													to={() => {
														const pageQuery = new URLSearchParams(window.location.search);
														return `/funecap/selfcare/${user.id}?p=${btoa(pageQuery.toString())}`;
													}}
													className="flex-column my-auto">
													<h4 className="h3 ls-n1 font-weight-black mt-auto mb-2 text-capitalize">
														{user.firstName} {user.lastName}
													</h4>
												</Link>
											</div>
											<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder py-1 bg-light">
												<span className="o-60">Date RDV: </span>
												<span className="text-uppercase mx-1">
													{new Intl.DateTimeFormat("fr-FR", {
														day: "2-digit",
														month: "2-digit",
														year: "numeric",
														hour: "2-digit",
														minute: "2-digit",
														hour12: false,
													})
														.format(user.meetingDate ? new Date(user.meetingDate) : new Date())
														.replace(", ", " ")}
												</span>
											</div>
											<div className="flex-row fs-2 mx-auto mb-auto justify-content-between align-items-center px-3 w-100 font-weight-bolder py-1">
												<div>
													<span className="o-60">Chargé: </span>
													<span className="text-uppercase mx-1">
														{user.operator}
													</span>
												</div>
												
											</div>
										</div>
									);
								})}
							</section>
						) : (
							<div className="flex-column p-3 mt-5 h-100 ">
								<div className="container container-base text-center m-auto">
									<h5 className="sr-only visually-hidden">Agent - Empty</h5>
									<div className="display-4 font-weight-black ls-n1 lh-1 mb-3">Aucun résultat</div>
									<p className="text-lg mb-4 o-66">Veuillez vérifier que les filtres appliqués correspondent bien à votre recherche.</p>
								</div>
							</div>
						)}
					</div>
				)}
				{/* <EnvoisProfile /> */}
				<ChangeOperator selectedUser={selectedUser} users={teleconseillers} isLoading={selfcareState.isLoading}></ChangeOperator>
			</div>
			<div className="container-fluid">
				<SelfcarePagination selfcareState={selfcareState} pageSearch={pageSearch} routerQuery={routerQuery} />
			</div>
		</article>
	);
};